export const team21 = [
  {
    name: "Competitive Programming",
    members: [
      {
        name: "Tom Thomas",
      },
      {
        name: "George Sabu",
      },
      {
        name: "Gautham S Baiju",
      },
      {
        name: "Athul Reji",
      },
      {
        name: "Jagannath E Shahi",
      },
      {
        name: "Snehal Sha",
      },
      {
        name: "George Mathew Pappady",
      },
    ],
  },
  {
    name: "Tech Team",
    members: [
      {
        name: "Hemanth R",
      },
      {
        name: "Gayathry S",
      },
      {
        name: "Aadhil Farhan K S",
      },

      {
        name: "Deepak Mathew",
      },
      {
        name: "Sona Mathew",
      },
      {
        name: "Sreehari Sreekumar",
      },
      {
        name: "Jaison Dennis",
      },
      {
        name: "Vishnu R Potti",
      },
      {
        name: "Amjad Ali",
      },
      {
        name: "Lisa V Cherian",
      },
    ],
  },
  {
    name: "Content Team",
    members: [
      {
        name: "Sharat Jacob Jacob",
      },
      {
        name: "Stephen Saji Mathew ",
      },
      {
        name: "Sneha shaji",
      },
      {
        name: "Reshma J Nair",
      },
      {
        name: "Sonah S Tiju",
      },
      {
        name: "Anish Pillai",
      },
      {
        name: "Ann Maria",
      },
      {
        name: "Mrinalini Nair Ani",
      },
      {
        name: "Diya Naushad",
      },
    ],
  },
  {
    name: "Design Team",
    members: [
      {
        name: "Shimil S Abraham",
      },
      {
        name: "Jessica Jolly",
      },
      {
        name: "Ashwin Girish",
      },
      {
        name: "Hana Shelbin",
      },
      {
        name: "Jeswin Thomas",
      },
      {
        name: "Netanya Jaison",
      },
      {
        name: "Kuriakose T Cyril",
      },
      {
        name: "Jemma Mariya George",
      },
      {
        name: "Adhil",
      },
      {
        name: "Henna k",
      },
      {
        name: "Annu Kuruvilla",
      },
      {
        name: "Anish Pillai",
      },
      {
        name: "Gourisankar Shaji",
      },
    ],
  },
  {
    name: "Outreach Team",
    members: [
      {
        name: "Hanna Salam",
      },
      {
        name: "Fayaz A P",
      },
      {
        name: "Arathy Sha A",
      },
      {
        name: "Sreehari Sreekumar",
      },
      {
        name: "Kalyani Reji",
      },
    ],
  },
  {
    name: "Events Team",
    members: [
      {
        name: "Anagha Sivadas",
      },
      {
        name: "Elizabeth Mathew",
      },
      {
        name: "Maria Rachel Joseph",
      },
      {
        name: "Swathy Prakash ",
      },
      {
        name: "K B Sree Lakshmy ",
      },
      {
        name: "Rose Mariya Davis ",
      },
      {
        name: "Lakshmi Sajilal",
      },
      {
        name: "Crystal Bejoy",
      },
      {
        name: "K B Sree Parvathy",
      },
    ],
  },
  {
    name: "Publicity Team",
    members: [
      {
        name: "Jaison Dennis",
      },
      {
        name: "Ann Maria",
      },
      {
        name: "Medha K",
      },
      {
        name: "J Vikaas",
      },
      {
        name: "Jubel Benny",
      },
      {
        name: "Sumayya Parvin",
      },
      {
        name: "Swathi Satheesh Chandran",
      },
      {
        name: "Saad Moopan",
      },
      {
        name: "Roshna Sunil",
      },
      {
        name: "Arjun Jayakumar",
      },
    ],
  },
];
